// Mock data for GreenLionEnergy website

export const translations = {
  de: {
    nav: {
      home: 'Startseite',
      services: 'Leistungen',
      about: 'Über uns',
      installation: 'Montageschritte',
      projects: 'Projekte',
      reviews: 'Bewertungen',
      contact: 'Kontakt'
    },
    hero: {
      title: 'GreenLionEnergy',
      subtitle: 'Die Kraft der Sonne. Die Stärke des Löwen',
      tagline: 'Gemeinsam machen wir Ihr Zuhause unabhängig, nachhaltig und voller Energie.',
      cta: 'Kostenlose Beratung erhalten',
      calculatorTitle: 'Kostenrechner'
    },
    calculator: {
      title: '☀ Dach- & Gebäudeinformationen für Ihre Solaranlage',
      subtitle: 'Bitte geben Sie die folgenden Informationen zu Ihrem Gebäude an, damit wir Ihr persönliches Angebot präzise berechnen können.',
      power: 'Anlagenleistung (kWp)',
      roofTypeLabel: '🏠 Dachtyp',
      roofTypeDesc: 'Wählen Sie den passenden Dachtyp für Ihre Solaranlage aus:',
      roofTypes: {
        satteldach: 'Satteldach – 200 € / kWp',
        flachdach: 'Flachdach – 200 € / kWp',
        trapez: 'Trapez- oder Wellendach – 200 € / kWp'
      },
      roofTypePriceNote: '(Der Preis für den Dachtyp bleibt immer gleich: 200 € pro kWp.)',
      additionalWorkLabel: '⚙ Zusätzlicher Aufwand am Dach',
      additionalWorkDesc: 'Bitte wählen Sie, falls zutreffend:',
      additionalWork: {
        none: 'Keine',
        pappdocken: 'Pappdocken → +108 € / kWp',
        vermoertelt: 'Vermörtelte Dachziegel → +108 € / kWp',
        fensterausbau: 'Fensterausbau → +200 €',
        satelliten: 'Satelliten verstellen/abbauen → +150 €',
        enphase: 'Enphase Mikrowechselrichter → +5 € / Stück'
      },
      cableLabel: '🔌 Kabelweg',
      cableDesc: 'Bitte geben Sie die ungefähre Kabellänge (vom Dach bis zum Wechselrichter) an:',
      cableMeters: 'Meter',
      cableNote: 'Ab einer Kabellänge von über 20 m kann ein zusätzlicher Aufwand entstehen.',
      gutterLabel: '🌧 Regenrinne',
      gutterDesc: 'Wählen Sie das Material Ihrer Regenrinne:',
      gutter: {
        metal: 'Metall → Kostenlos bis 4,5 m Höhe',
        plastic: 'Kunststoff → Pauschal +500 €'
      },
      gutterNote: 'Bei höherer Montage: +80 € pro 0,5 m zusätzlicher Höhe',
      heightLabel: '📏 Gebäudehöhe',
      heightDesc: 'Höhe vom Boden bis zur Regenrinne:',
      heightMeters: 'Meter',
      calculate: 'Berechnen',
      result: 'Gesamtpreis',
      footNote: '📩 Hinweis: Je genauer Ihre Angaben sind, desto präziser können wir Ihre Solaranlage planen und den Gesamtpreis kalkulieren.'
    },
    advantages: {
      title: 'Unsere Vorteile',
      honest: {
        title: 'Ehrlicher Preis',
        text: 'Transparente Kalkulation ohne versteckte Kosten'
      },
      quality: {
        title: 'Top-Qualität',
        text: 'Über 350 erfolgreich montierte Anlagen'
      },
      speed: {
        title: 'Schnelle Montage',
        text: 'Effiziente Installation durch erfahrenes Team'
      },
      guarantee: {
        title: 'Garantie',
        text: 'Vollständiges Abnahmeprotokoll mit Fotodokumentation'
      }
    },
    services: {
      title: 'Unsere Leistungen',
      subtitle: 'Professionelle DC-Montage ab 200 €/kWp',
      dcInstallation: {
        title: 'DC-Montage',
        price: 'ab 200 €/kWp',
        features: [
          'Professionelle Montage der Module',
          'Unterkonstruktion nach Maß',
          'Verkabelung und Anschluss',
          'Gerüst inklusive'
        ]
      },
      protocol: {
        title: 'Abnahmeprotokoll',
        features: [
          'Vollständige Fotodokumentation',
          'Technische Prüfung',
          'Übergabeprotokoll',
          'Garantieunterlagen'
        ]
      },
      planning: {
        title: 'Drohnenplanung',
        features: [
          'Dachvermessung per Drohne',
          'Optimale Modulplatzierung',
          'Verschattungsanalyse',
          'Präzise Vorbereitung'
        ]
      },
      turnkey: {
        title: 'Komplett-Installationen',
        subtitle: 'Jetzt verfügbar!',
        features: [
          'PV-Anlage + Batteriespeicher',
          'Wallbox für E-Mobilität',
          'Wärmepumpe Integration',
          'Alles aus einer Hand'
        ]
      }
    },
    about: {
      title: 'Über uns',
      subtitle: 'Stark wie ein Löwe – Deine Energie, dein Partner!',
      intro: 'Löwen stehen in der Natur für Stärke, Mut und Zusammenhalt – genau diese Werte leben wir bei Green Lion Energy jeden Tag.',
      story: 'Als eingetragener Dachdeckermeisterbetrieb aus der Region Bremen & Delmenhorst verbinden wir traditionelles Handwerk mit moderner Energietechnik. Mit über 350 erfolgreich umgesetzten Photovoltaik-Baustellen gehören wir zu den erfahrensten Montagebetrieben im Norden.',
      mission: 'Unser Ziel ist klar: eine nachhaltige Zukunft mit sauberer Energie – stark umgesetzt, fair geplant und professionell montiert.',
      values: {
        title: 'Warum Löwen?',
        reliability: {
          title: 'Zuverlässig: Warum Löwen für Vertrauen stehen',
          text: 'In der Wildnis zählt das Vertrauen im Rudel – und genauso ist es bei uns. Wir stehen für Zuverlässigkeit, Qualität und langfristige Partnerschaften. Von der ersten Beratung bis zur letzten Dachschraube: Auf Green Lion Energy ist Verlass.'
        },
        speed: {
          title: 'Schnell: Warum Löwen entschlossen handeln',
          text: 'Wenn ein Löwe handelt, dann mit Präzision. Auch wir verlieren keine Zeit – von der Planung bis zur Montage setzen wir dein Projekt innerhalb weniger Wochen um. Effizient, termintreu und auf höchstem handwerklichem Niveau.'
        },
        strength: {
          title: 'Stark: Warum Löwen Ausdauer haben',
          text: 'Unsere Stärke liegt in Erfahrung und Handwerkskunst. Mit mehr als 350 realisierten Anlagen wissen wir genau, worauf es ankommt – bei jedem Dach, jeder Anlage, jedem Detail. Green Lion Energy steht für Beständigkeit, Qualität und Energie, die bleibt.'
        },
        teamwork: {
          title: 'Professionell: Warum Löwen im Team erfolgreich sind',
          text: 'Ein Löwe ist nur so stark wie sein Rudel – und unser Team ist unser größter Stolz. Als Meisterbetrieb legen wir Wir Wert auf Teamgeist, Fachwissen und saubere Arbeit. Jede Anlage ist ein Versprechen: grüne Energie – stark wie ein Löwe.'
        }
      }
    },
    installation: {
      title: 'Montageschritte',
      subtitle: 'So arbeiten wir — transparent und professionell',
      steps: [
        {
          number: '01',
          title: 'Ankunft & Vorbereitung',
          description: 'Materialkontrolle, Gerüstaufbau, Sicherheitseinweisung'
        },
        {
          number: '02',
          title: 'Montage Unterkonstruktion',
          description: 'Befestigung der Haken, Ausrichtung der Schienen'
        },
        {
          number: '03',
          title: 'Modulinstallation',
          description: 'Präzise Verlegung und Befestigung der Solarmodule'
        },
        {
          number: '04',
          title: 'Prüfung & Dokumentation',
          description: 'Technische Kontrolle, Fotodokumentation jedes Details'
        },
        {
          number: '05',
          title: 'Abnahme mit Kunde',
          description: 'Gemeinsame Begehung, Protokollübergabe'
        },
        {
          number: '06',
          title: 'Abschluss & Abrechnung',
          description: 'Gerüstabbau, Reinigung, finale Dokumentation'
        }
      ]
    },
    projects: {
      title: 'Unsere Projekte',
      subtitle: 'Über 350 erfolgreich montierte Anlagen',
      items: [
        {
          id: 1,
          name: '12,42 kWp Solaranlage in Bremen',
          type: 'Einfamilienhaus',
          power: '12,42 kWp',
          modules: '27 Module',
          savings: '€3.200/Jahr',
          duration: '2 Tage',
          storage: '10 kWh Speicher',
          autarky: '82% Autarkiegrad',
          amortization: 'Amortisation nach 9,8 Jahren',
          completion: 'Fertiggestellt innerhalb von 9 Wochen',
          details: 'Satteldach mit Ziegeln, 35° Neigung. Optimale Südausrichtung. Ecoflow Wechselrichter + Speicher 10 kWh. Kabellänge 18m.',
          image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/ye2pufoo_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.36.11_50cba754.jpg'
        },
        {
          id: 2,
          name: '13,8 kWp Solaranlage in Oldenburg',
          type: 'Einfamilienhaus',
          power: '13,8 kWp',
          modules: '30 Module',
          savings: '€3.600/Jahr',
          duration: '2 Tage',
          storage: '10 kWh Speicher',
          autarky: 'ca. 85% Autarkiegrad',
          amortization: 'Amortisation nach nur 8,7 Jahren',
          completion: 'Fertiggestellt innerhalb von 9 Wochen',
          description: 'Besonders starkes Preis-Leistungs-Verhältnis',
          details: 'Flachdach mit Ost-West-Ausrichtung. Fronius Wechselrichter. Unterkonstruktion mit S-Flex Gestell. Gerüsthöhe 6m.',
          image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/bln95hbp_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.39.13_ef3c5de5.jpg'
        },
        {
          id: 3,
          name: '13,8 kWp Solaranlage in Delmenhorst',
          type: 'Einfamilienhaus',
          power: '13,8 kWp',
          modules: '30 Module',
          savings: '€3.500/Jahr',
          duration: '2 Tage',
          storage: '10 kWh Speicher',
          autarky: 'ca. 85% Autarkiegrad',
          amortization: 'Amortisation nach nur 8,7 Jahren',
          completion: 'Fertiggestellt innerhalb von 9 Wochen',
          description: 'Besonders starkes Preis-Leistungs-Verhältnis',
          details: 'Satteldach mit Betondachsteinen. Süd-West-Ausrichtung 40°. Sigenergy Hybrid-Wechselrichter. Fensterausbau erforderlich.',
          image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/ukeh94em_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.40.21_f50391fa.jpg'
        }
      ]
    },
    reviews: {
      title: 'Kundenbewertungen',
      subtitle: 'Das sagen unsere Kunden über uns',
      message: 'Echte Bewertungen von echten Kunden',
      cta: 'Bewertung auf Google abgeben',
      googleRating: 5.0,
      totalReviews: 2,
      items: [
        {
          id: 1,
          author: 'Peter Wollter',
          rating: 5,
          date: 'vor 1 Monat',
          text: 'Ich habe die Jungs über Kleinanzeigen gefunden. Ein junges Unternehmen, aber vom ersten Kontakt an sehr professionell! Am Tag der Montage haben sie genau das auch gezeigt – zuverlässig, sauber und mit top Ergebnis. Meine Frau und ich möchten uns nochmal herzlich bedanken und wünschen euch weiterhin viel Erfolg!',
          verified: true
        },
        {
          id: 2,
          author: 'Thomas Meyer',
          rating: 5,
          date: 'vor 2 Monaten',
          text: 'Green Lion Energy hat bei uns die DC-Montage ausgeführt. Wir haben die Komponenten selbst bestellt, um Kosten zu sparen. Ich kann nur Positives über das Unternehmen sagen, wir haben definitiv die richtige Entscheidung getroffen.',
          verified: true
        }
      ]
    },
    tiktok: {
      title: 'Überzeugen Sie sich selbst von unserer Arbeit',
      subtitle: 'Hautnah dabei sein, wie eine Anlage von Anfang bis Ende gebaut wird',
      description: 'Damit Sie das Gefühl haben, wie es abläuft und Sie sich von unserer Qualität überzeugen - mit Taten nicht mit Wörtern',
      account: '@greenlion.energy',
      cta: 'Jetzt auf TikTok folgen'
    },
    contact: {
      title: 'Kontakt',
      subtitle: 'Lassen Sie uns Ihr Solarprojekt besprechen',
      company: 'Green Lion Energy GbR',
      address: 'Nordenhamer Straße 180',
      location: '27751 Delmenhorst, Deutschland',
      phone: '04221-2959978',
      whatsapp: 'WhatsApp-Chat',
      email: 'info@greenlionenergy.de',
      hours: 'Mo–Fr: 7:00–18:00 Uhr, Sa: 8:00–15:00 Uhr, So: geschlossen',
      form: {
        title: 'Anfrage senden',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        message: 'Ihre Nachricht',
        submit: 'Anfrage senden',
        success: 'Vielen Dank! Wir melden uns bald bei Ihnen.',
        error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.'
      }
    },
    partners: {
      title: 'Unsere Partner',
      subtitle: 'Wir arbeiten mit den besten Marken der Branche zusammen'
    },
    footer: {
      tagline: '„Wir montieren nicht nur Panels — wir bauen Vertrauen."',
      slogan: 'Montage mit Charakter',
      rights: '© 2025 GreenLionEnergy GbR. Alle Rechte vorbehalten.'
    }
  },
  ru: {
    nav: {
      home: 'Главная',
      services: 'Услуги',
      about: 'О нас',
      installation: 'Этапы монтажа',
      projects: 'Проекты',
      reviews: 'Отзывы',
      contact: 'Контакты'
    },
    hero: {
      title: 'GreenLionEnergy',
      subtitle: 'Солнечная энергия с характером',
      tagline: '„Солнце работает на вас — а мы работаем для вас."',
      cta: 'Получить бесплатную консультацию',
      calculatorTitle: 'Калькулятор стоимости'
    },
    calculator: {
      title: 'Рассчитайте вашу солнечную систему',
      power: 'Мощность системы (кВт)',
      roofType: 'Тип крыши',
      roofTypes: {
        pitched: 'Двускатная',
        flat: 'Плоская',
        metal: 'Металлическая'
      },
      scaffolding: 'Требуются леса?',
      yes: 'Да',
      no: 'Нет',
      calculate: 'Рассчитать',
      result: 'Предварительная стоимость',
      pricePerKw: '200 €/кВт за DC-монтаж',
      includes: 'Включено: леса, протокол приёмки, планирование с дрона'
    },
    advantages: {
      title: 'Наши преимущества',
      honest: {
        title: 'Честная цена',
        text: 'Прозрачный расчёт без скрытых платежей'
      },
      quality: {
        title: 'Качество',
        text: 'Более 350 успешно смонтированных систем'
      },
      speed: {
        title: 'Скорость',
        text: 'Эффективная установка опытной командой'
      },
      guarantee: {
        title: 'Гарантия',
        text: 'Полный протокол приёмки с фотофиксацией'
      }
    },
    services: {
      title: 'Наши услуги',
      subtitle: 'Профессиональный DC-монтаж от 200 €/кВт',
      dcInstallation: {
        title: 'DC-монтаж',
        price: 'от 200 €/кВт',
        features: [
          'Профессиональный монтаж модулей',
          'Подконструкция по размеру',
          'Прокладка кабелей и подключение',
          'Леса включены'
        ]
      },
      protocol: {
        title: 'Протокол приёмки',
        features: [
          'Полная фотодокументация',
          'Техническая проверка',
          'Протокол передачи',
          'Гарантийные документы'
        ]
      },
      planning: {
        title: 'Планирование с дрона',
        features: [
          'Измерение крыши дроном',
          'Оптимальное размещение модулей',
          'Анализ затенения',
          'Точная подготовка'
        ]
      },
      turnkey: {
        title: 'Установка под ключ',
        subtitle: '(В планах)',
        features: [
          'Солнечная система под ключ',
          'От планирования до запуска',
          'Всё из одних рук',
          'Вкл. электромонтаж'
        ]
      }
    },
    about: {
      title: 'О нас',
      subtitle: 'Сильный как лев — твоя энергия, твой партнёр!',
      intro: 'Львы в природе символизируют силу, мужество и сплочённость — именно эти ценности мы воплощаем в Green Lion Energy каждый день.',
      story: 'Как зарегистрированное предприятие кровельных работ из региона Бремен и Дельменгорст, мы объединяем традиционное ремесло с современной энергетикой. С более чем 350 успешно реализованными проектами солнечных электростанций мы входим в число самых опытных монтажных компаний на севере Германии.',
      mission: 'Наша цель ясна: устойчивое будущее с чистой энергией — надёжно реализованное, справедливо спланированное и профессионально смонтированное.',
      values: {
        title: 'Почему львы?',
        reliability: {
          title: 'Надёжность: почему львы — символ доверия',
          text: 'В дикой природе доверие внутри прайда имеет решающее значение — и у нас всё так же. Мы стоим за надёжность, качество и долгосрочное партнёрство. От первой консультации до последнего винта: на Green Lion Energy можно положиться.'
        },
        speed: {
          title: 'Скорость: почему львы действуют решительно',
          text: 'Когда лев действует — он делает это точно. Мы тоже не теряем времени: от планирования до монтажа мы реализуем ваш проект всего за несколько недель. Эффективно, точно в срок и на высочайшем уровне мастерства.'
        },
        strength: {
          title: 'Сила: почему львы обладают выносливостью',
          text: 'Наша сила — в опыте и мастерстве. С более чем 350 реализованными установками мы точно знаем, что важно — для каждой крыши, каждой системы, каждой детали. Green Lion Energy — это надёжность, качество и энергия, которая остаётся.'
        },
        teamwork: {
          title: 'Профессионализм: почему львы успешны в команде',
          text: 'Лев силён своей стаей — и наша команда — наша главная гордость. Как мастерская компания, мы ценим командный дух, профессиональные знания и чистую работу. Каждая установка — это обещание: зелёная энергия — сильная как лев.'
        }
      }
    },
    installation: {
      title: 'Этапы монтажа',
      subtitle: 'Так мы работаем — прозрачно и профессионально',
      steps: [
        {
          number: '01',
          title: 'Прибытие и подготовка',
          description: 'Проверка материалов, установка лесов, инструктаж по безопасности'
        },
        {
          number: '02',
          title: 'Монтаж подконструкции',
          description: 'Крепление крюков, выравнивание направляющих'
        },
        {
          number: '03',
          title: 'Установка модулей',
          description: 'Точная укладка и крепление солнечных модулей'
        },
        {
          number: '04',
          title: 'Проверка и документация',
          description: 'Техническая проверка, фотофиксация каждой детали'
        },
        {
          number: '05',
          title: 'Приёмка с клиентом',
          description: 'Совместный обход, передача протокола'
        },
        {
          number: '06',
          title: 'Завершение и расчёт',
          description: 'Демонтаж лесов, уборка, финальная документация'
        }
      ]
    },
    projects: {
      title: 'Наши проекты',
      subtitle: 'Более 350 успешно смонтированных систем',
      items: [
        {
          id: 1,
          name: 'Солнечная система 12,42 кВт в Бремене',
          type: 'Частный дом',
          power: '12,42 кВт',
          storage: 'Накопитель 10 кВтч',
          autarky: 'Автономность 82%',
          amortization: 'Окупаемость через 9,8 лет',
          completion: 'Завершено за 9 недель',
          image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/ye2pufoo_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.36.11_50cba754.jpg'
        },
        {
          id: 2,
          name: 'Солнечная система 13,8 кВт в Ольденбурге',
          type: 'Частный дом',
          power: '13,8 кВт',
          storage: 'Накопитель 10 кВтч',
          autarky: 'Автономность ок. 85%',
          amortization: 'Окупаемость всего через 8,7 лет',
          completion: 'Завершено за 9 недель',
          description: 'Особенно выгодное соотношение цены и качества',
          image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/bln95hbp_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.39.13_ef3c5de5.jpg'
        },
        {
          id: 3,
          name: 'Солнечная система 13,8 кВт в Дельменхорсте',
          type: 'Частный дом',
          power: '13,8 кВт',
          storage: 'Накопитель 10 кВтч',
          autarky: 'Автономность ок. 85%',
          amortization: 'Окупаемость всего через 8,7 лет',
          completion: 'Завершено за 9 недель',
          description: 'Особенно выгодное соотношение цены и качества',
          image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/ukeh94em_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.40.21_f50391fa.jpg'
        }
      ]
    },
    reviews: {
      title: 'Отзывы клиентов',
      subtitle: 'Мы только начинаем путь под брендом GreenLionEnergy',
      message: 'Отзывы собираются с нуля — без накруток, только реальные мнения.',
      cta: 'Оставить отзыв',
      placeholder: 'Ваши первые настоящие отзывы скоро появятся здесь!'
    },
    contact: {
      title: 'Контакты',
      subtitle: 'Давайте обсудим ваш солнечный проект',
      company: 'Green Lion Energy GbR',
      address: 'Nordenhamer Straße 180',
      location: '27751 Дельменхорст, Германия',
      phone: '04221-2959978',
      whatsapp: 'WhatsApp-чат',
      email: 'info@greenlionenergy.de',
      hours: 'Пн–Пт: 7:00–18:00, Сб: 8:00–15:00, Вс: закрыто',
      form: {
        title: 'Отправить заявку',
        name: 'Имя',
        email: 'E-mail',
        phone: 'Телефон',
        message: 'Ваше сообщение',
        submit: 'Отправить заявку',
        success: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
        error: 'Ошибка отправки. Пожалуйста, попробуйте снова.'
      }
    },
    footer: {
      tagline: '„Мы не просто монтируем панели — мы строим доверие."',
      slogan: 'Монтаж с характером',
      rights: '© 2025 GreenLionEnergy GbR. Все права защищены.'
    }
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetler',
      about: 'Hakkımızda',
      installation: 'Kurulum Aşamaları',
      projects: 'Projeler',
      reviews: 'Yorumlar',
      contact: 'İletişim'
    },
    hero: {
      title: 'GreenLionEnergy',
      subtitle: 'Karakterli Güneş Enerjisi',
      tagline: '„Güneş sizin için çalışır — biz de sizin için çalışırız."',
      cta: 'Ücretsiz Danışmanlık Alın',
      calculatorTitle: 'Maliyet Hesaplayıcı'
    },
    calculator: {
      title: 'Güneş Sisteminizi Hesaplayın',
      power: 'Sistem Gücü (kWp)',
      roofType: 'Çatı Tipi',
      roofTypes: {
        pitched: 'Eğimli Çatı',
        flat: 'Düz Çatı',
        metal: 'Metal Çatı'
      },
      scaffolding: 'İskele gerekli mi?',
      yes: 'Evet',
      no: 'Hayır',
      calculate: 'Hesapla',
      result: 'Tahmini Maliyet',
      pricePerKw: 'DC montaj için 200 €/kWp',
      includes: 'Dahil: İskele, montaj protokolü, drone planlaması'
    },
    advantages: {
      title: 'Avantajlarımız',
      honest: {
        title: 'Dürüst Fiyat',
        text: 'Gizli maliyetler olmadan şeffaf hesaplama'
      },
      quality: {
        title: 'Kalite',
        text: '250\'den fazla başarıyla monte edilmiş sistem'
      },
      speed: {
        title: 'Hız',
        text: 'Deneyimli ekip tarafından verimli kurulum'
      },
      guarantee: {
        title: 'Garanti',
        text: 'Fotoğraf dokümantasyonu ile tam teslim protokolü'
      }
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Profesyonel DC Montaj 200 €/kWp\'den başlayan fiyatlarla',
      dcInstallation: {
        title: 'DC Montaj',
        price: '200 €/kWp\'den başlar',
        features: [
          'Modüllerin profesyonel montajı',
          'Ölçüye göre alt yapı',
          'Kablolama ve bağlantı',
          'İskele dahil'
        ]
      },
      protocol: {
        title: 'Teslim Protokolü',
        features: [
          'Tam fotoğraf dokümantasyonu',
          'Teknik inceleme',
          'Teslim protokolü',
          'Garanti belgeleri'
        ]
      },
      planning: {
        title: 'Drone Planlaması',
        features: [
          'Drone ile çatı ölçümü',
          'Optimal modül yerleşimi',
          'Gölgeleme analizi',
          'Hassas hazırlık'
        ]
      },
      turnkey: {
        title: 'Anahtar Teslim Kurulum',
        subtitle: '(Planlamada)',
        features: [
          'Anahtar teslim güneş sistemi',
          'Planlamadan devreye almaya',
          'Her şey tek elden',
          'Elektrik kurulumu dahil'
        ]
      }
    },
    about: {
      title: 'Hakkımızda',
      subtitle: 'Kalite ve dürüstlük her şeyden önce',
      story: 'Adım Deyвid Tratar, GreenLionEnergy\'nin kurucusuyum. 250\'den fazla başarıyla monte edilmiş güneş sistemi ve Solar-Biber GmbH ve LüneSolar E.K. deneyimi ile ortağım Nicolae Ciobanu ile birlikte kalite ve dürüstlüğü her şeyin üstünde tutan bir şirket kurduk.',
      values: {
        title: 'Değerlerimiz',
        honesty: 'Dürüstlük',
        quality: 'Kalite',
        proximity: 'Yakınlık',
        responsibility: 'Sorumluluk'
      },
      lion: 'Şirket aslanımız güç, güvenilirlik ve dostluğu simgeler — tıpkı ekibimiz gibi.'
    },
    installation: {
      title: 'Kurulum Aşamaları',
      subtitle: 'Böyle çalışıyoruz — şeffaf ve profesyonel',
      steps: [
        {
          number: '01',
          title: 'Varış ve Hazırlık',
          description: 'Malzeme kontrolü, iskele kurulumu, güvenlik brifing'
        },
        {
          number: '02',
          title: 'Alt Yapı Montajı',
          description: 'Kancaların sabitlenmesi, rayların hizalanması'
        },
        {
          number: '03',
          title: 'Modül Kurulumu',
          description: 'Güneş modüllerinin hassas döşenmesi ve sabitlenmesi'
        },
        {
          number: '04',
          title: 'Kontrol ve Dokümantasyon',
          description: 'Teknik kontrol, her detayın fotoğraflanması'
        },
        {
          number: '05',
          title: 'Müşteri ile Teslim',
          description: 'Birlikte gezinti, protokol teslimi'
        },
        {
          number: '06',
          title: 'Sonlandırma ve Faturalandırma',
          description: 'İskele sökümü, temizlik, final dokümantasyonu'
        }
      ]
    },
    projects: {
      title: 'Projelerimiz',
      subtitle: '250\'den fazla başarıyla monte edilmiş sistem',
      items: [
        {
          id: 1,
          name: 'Delmenhorst Projesi',
          type: 'Müstakil ev',
          power: '8,01 kWp',
          roofType: 'Eğimli çatı, kiremit',
          date: 'Eylül 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/5hrqwww3_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_374e8e96.jpg'
        },
        {
          id: 2,
          name: 'Bremen Projesi',
          type: 'Müstakil ev',
          power: '6,5 kWp',
          roofType: 'Düz çatı',
          date: 'Ağustos 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/1tugeup6_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_7d83d887.jpg'
        },
        {
          id: 3,
          name: 'Modern Çatı Sistemi',
          type: 'Sıra ev',
          power: '9,2 kWp',
          roofType: 'Metal çatı',
          date: 'Ekim 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/ncbt3vkm_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_3a4bdd99.jpg'
        },
        {
          id: 4,
          name: 'Oldenburg Projesi',
          type: 'Müstakil ev',
          power: '7,8 kWp',
          roofType: 'Eğimli çatı',
          date: 'Temmuz 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/sgu4l59h_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_7d7dd5c7.jpg'
        }
      ]
    },
    reviews: {
      title: 'Müşteri Yorumları',
      subtitle: 'GreenLionEnergy markası altında yolculuğumuza başlıyoruz',
      message: 'Yorumlar sıfırdan toplanıyor — hilesiz, sadece gerçek görüşler.',
      cta: 'Yorum Bırak',
      placeholder: 'İlk gerçek yorumlarınız yakında burada görünecek!'
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Güneş projenizi konuşalım',
      company: 'GreenLionEnergy GbR',
      location: 'Delmenhorst, Aşağı Saksonya, Almanya',
      whatsapp: 'WhatsApp Sohbet',
      email: 'info@greenlionenergy.de',
      hours: 'Pzt–Cmt 08:00–18:00',
      form: {
        title: 'Talep Gönder',
        name: 'Ad',
        email: 'E-posta',
        phone: 'Telefon',
        message: 'Mesajınız',
        submit: 'Talep Gönder',
        success: 'Teşekkürler! Yakında sizinle iletişime geçeceğiz.',
        error: 'Gönderim hatası. Lütfen tekrar deneyin.'
      }
    },
    footer: {
      tagline: '„Sadece panel monte etmiyoruz — güven inşa ediyoruz."',
      slogan: 'Karakterli Montaj',
      rights: '© 2025 GreenLionEnergy GbR. Tüm hakları saklıdır.'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      services: 'الخدمات',
      about: 'من نحن',
      installation: 'مراحل التركيب',
      projects: 'المشاريع',
      reviews: 'التقييمات',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'GreenLionEnergy',
      subtitle: 'الطاقة الشمسية بشخصية',
      tagline: '„الشمس تعمل من أجلك — ونحن نعمل من أجلك."',
      cta: 'احصل على استشارة مجانية',
      calculatorTitle: 'حاسبة التكلفة'
    },
    calculator: {
      title: 'احسب نظامك الشمسي',
      power: 'قوة النظام (كيلوواط)',
      roofType: 'نوع السقف',
      roofTypes: {
        pitched: 'سقف مائل',
        flat: 'سقف مسطح',
        metal: 'سقف معدني'
      },
      scaffolding: 'هل السقالات مطلوبة؟',
      yes: 'نعم',
      no: 'لا',
      calculate: 'احسب',
      result: 'التكلفة التقديرية',
      pricePerKw: '200 يورو/كيلوواط لتركيب DC',
      includes: 'يتضمن: سقالات، بروتوكول التركيب، التخطيط بالطائرة بدون طيار'
    },
    advantages: {
      title: 'مزايانا',
      honest: {
        title: 'سعر صادق',
        text: 'حساب شفاف بدون تكاليف مخفية'
      },
      quality: {
        title: 'الجودة',
        text: 'أكثر من 350 نظامًا مركبًا بنجاح'
      },
      speed: {
        title: 'السرعة',
        text: 'تركيب فعال من قبل فريق ذو خبرة'
      },
      guarantee: {
        title: 'الضمان',
        text: 'بروتوكول استلام كامل مع توثيق بالصور'
      }
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'تركيب DC احترافي من 200 يورو/كيلوواط',
      dcInstallation: {
        title: 'تركيب DC',
        price: 'من 200 يورو/كيلوواط',
        features: [
          'تركيب احترافي للوحدات',
          'بنية تحتية حسب المقاس',
          'توصيل الكابلات والتوصيل',
          'السقالات مشمولة'
        ]
      },
      protocol: {
        title: 'بروتوكول الاستلام',
        features: [
          'توثيق كامل بالصور',
          'فحص فني',
          'بروتوكول التسليم',
          'وثائق الضمان'
        ]
      },
      planning: {
        title: 'التخطيط بالطائرة بدون طيار',
        features: [
          'قياس السقف بالطائرة بدون طيار',
          'وضع الوحدات الأمثل',
          'تحليل التظليل',
          'تحضير دقيق'
        ]
      },
      turnkey: {
        title: 'التركيب الكامل',
        subtitle: '(قيد التخطيط)',
        features: [
          'نظام شمسي جاهز للاستخدام',
          'من التخطيط إلى التشغيل',
          'كل شيء من مصدر واحد',
          'بما في ذلك التركيب الكهربائي'
        ]
      }
    },
    about: {
      title: 'من نحن',
      subtitle: 'الجودة والصدق في المقام الأول',
      story: 'اسمي ديفيد تراتار، أنا مؤسس GreenLionEnergy. مع أكثر من 350 نظامًا شمسيًا مركبًا بنجاح وخبرة في Solar-Biber GmbH و LüneSolar E.K.، أسست أنا وشريكي نيكولاي شيوبانو شركة تضع الجودة والصدق فوق كل شيء.',
      values: {
        title: 'قيمنا',
        honesty: 'الصدق',
        quality: 'الجودة',
        proximity: 'القرب',
        responsibility: 'المسؤولية'
      },
      lion: 'أسدنا الرمزي يرمز إلى القوة والموثوقية والود — تمامًا مثل فريقنا.'
    },
    installation: {
      title: 'مراحل التركيب',
      subtitle: 'هكذا نعمل — بشفافية واحترافية',
      steps: [
        {
          number: '01',
          title: 'الوصول والتحضير',
          description: 'فحص المواد، إعداد السقالات، إحاطة السلامة'
        },
        {
          number: '02',
          title: 'تركيب البنية التحتية',
          description: 'تثبيت الخطافات، محاذاة القضبان'
        },
        {
          number: '03',
          title: 'تركيب الوحدات',
          description: 'وضع دقيق وتثبيت الوحدات الشمسية'
        },
        {
          number: '04',
          title: 'الفحص والتوثيق',
          description: 'الفحص الفني، توثيق كل التفاصيل بالصور'
        },
        {
          number: '05',
          title: 'الاستلام مع العميل',
          description: 'جولة مشتركة، تسليم البروتوكول'
        },
        {
          number: '06',
          title: 'الإكمال والفوترة',
          description: 'إزالة السقالات، التنظيف، التوثيق النهائي'
        }
      ]
    },
    projects: {
      title: 'مشاريعنا',
      subtitle: 'أكثر من 350 نظامًا مركبًا بنجاح',
      items: [
        {
          id: 1,
          name: 'مشروع ديلمنهورست',
          type: 'منزل عائلي',
          power: '8.01 كيلوواط',
          roofType: 'سقف مائل، بلاط',
          date: 'سبتمبر 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/5hrqwww3_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_374e8e96.jpg'
        },
        {
          id: 2,
          name: 'مشروع بريمن',
          type: 'منزل عائلي',
          power: '6.5 كيلوواط',
          roofType: 'سقف مسطح',
          date: 'أغسطس 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/1tugeup6_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_7d83d887.jpg'
        },
        {
          id: 3,
          name: 'نظام سقف حديث',
          type: 'منزل متلاصق',
          power: '9.2 كيلوواط',
          roofType: 'سقف معدني',
          date: 'أكتوبر 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/ncbt3vkm_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_3a4bdd99.jpg'
        },
        {
          id: 4,
          name: 'مشروع أولدنبورغ',
          type: 'منزل عائلي',
          power: '7.8 كيلوواط',
          roofType: 'سقف مائل',
          date: 'يوليو 2025',
          image: 'https://customer-assets.emergentagent.com/job_9652704e-5690-4f12-a6a5-a265d365bb10/artifacts/sgu4l59h_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-14%20%D0%B2%2022.16.50_7d7dd5c7.jpg'
        }
      ]
    },
    reviews: {
      title: 'تقييمات العملاء',
      subtitle: 'نبدأ رحلتنا تحت علامة GreenLionEnergy',
      message: 'يتم جمع التقييمات من الصفر — بدون خدع، آراء حقيقية فقط.',
      cta: 'اترك تقييمًا',
      placeholder: 'تقييماتك الحقيقية الأولى ستظهر هنا قريبًا!'
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'دعنا نناقش مشروعك الشمسي',
      company: 'GreenLionEnergy GbR',
      location: 'ديلمنهورست، ساكسونيا السفلى، ألمانيا',
      whatsapp: 'دردشة واتساب',
      email: 'info@greenlionenergy.de',
      hours: 'الاثنين–السبت 08:00–18:00',
      form: {
        title: 'إرسال طلب',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        message: 'رسالتك',
        submit: 'إرسال الطلب',
        success: 'شكرًا! سنتواصل معك قريبًا.',
        error: 'خطأ في الإرسال. يرجى المحاولة مرة أخرى.'
      }
    },
    footer: {
      tagline: '„نحن لا نركب الألواح فحسب — نبني الثقة."',
      slogan: 'تركيب بشخصية',
      rights: '© 2025 GreenLionEnergy GbR. جميع الحقوق محفوظة.'
    }
  }
};

export const lionImages = {
  logo: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/wvq75rmv_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.48.14_251b635f.jpg',
  aboutImage: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/pioozeef_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.48.58_0ea48adc.jpg',
  backgroundImage: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/pmqatuas_%D0%98%D0%B7%D0%BE%D0%B1%D1%80%D0%B0%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20WhatsApp%202025-10-15%20%D0%B2%2013.51.40_f10060e4.jpg'
};

export const partnerLogos = [
  {
    id: 1,
    name: 'K2 Systems',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/dv5xmova_logo_512x512.webp'
  },
  {
    id: 2,
    name: 'eKV NORD',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/ai7uyztk_eKV%20NORD.jpg'
  },
  {
    id: 3,
    name: 'Würth',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/nmf1tch4_w%C3%BCrth.png'
  },
  {
    id: 4,
    name: 'Aiko',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/h4bq6be1_aiko.png'
  },
  {
    id: 5,
    name: 'Ecoflow',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/bx78pbso_ecoflow.jpg'
  },
  {
    id: 6,
    name: 'CC Gruppe',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/4n428hu9_CC%20gruppe.png'
  },
  {
    id: 7,
    name: 'Sig Energy',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/lbbyo1r8_sig%20enrgy.jpg'
  },
  {
    id: 8,
    name: 'S-Flex',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/kwkrfw82_s%20flex.png'
  },
  {
    id: 9,
    name: 'Schletter',
    image: 'https://customer-assets.emergentagent.com/job_solar-lion/artifacts/d86ifwux_schletter.webp'
  }
];